import { Modal, ModalButtonProps, ModalWidthEnum, NotificationProps, NotificationTypeEnum, useMediaSize } from 'Components/designSystem';
import { OfferNoteBlock } from 'pages/candidateOffer/components';
import React, { useMemo } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { useErrorText } from 'shared/i18n';

import { ErrorTypes } from '../../../../shared/api';
import { CANDIDATE_OFFER_ACCEPT_CONTEXT } from '../../constants';

interface AcceptOfferDialogProps {
    closeDialog(): void;
    onConfirm(): void;
    error: string | undefined;
    submitting: boolean;    
    customer: string | undefined;
    selectedItemsCount: number;
    open: boolean;
}

export default function AcceptOfferDialog({ closeDialog, onConfirm, error, submitting, customer, selectedItemsCount, open }: AcceptOfferDialogProps) {
    const { t } = useTranslation('candidateOffers');
    const errorText = useErrorText();
    const { isMobile } = useMediaSize();
    
    const errorNotification = useMemo<NotificationProps | undefined>(() => {
        if (!error) {
            return undefined;
        }

        return {
            type: NotificationTypeEnum.Error,
            text: errorText(
                error,
                error === ErrorTypes.DeprecatedOrderData ? CANDIDATE_OFFER_ACCEPT_CONTEXT : undefined
            )
        };
    }, [ error, errorText ]);

    const submitButton = useMemo<ModalButtonProps>(() => ({
        action: onConfirm,
        inProgress: submitting,
        title: t('dialog.accept.submit')
    }), [ submitting, onConfirm, t ]);

    const cancelButton = useMemo<ModalButtonProps>(() => ({
        action: closeDialog,
        disabled: submitting,
        showAsCross: true
    }), [ closeDialog, submitting ]);

    return (
        <Modal
            title={ t('dialog.accept.title') }
            subTitle={ (
                <Trans t={ t }
                    i18nKey="dialog.accept.subtitle"
                    count={ selectedItemsCount }
                >
                    Please confirm that you apply for <b>1 assignments</b> at {{ customer: customer }}
                </Trans>
            ) }
            buttonAction={ submitButton }
            buttonCancel={ cancelButton }
            notification={ errorNotification }
            width={ isMobile ? ModalWidthEnum.FULL : ModalWidthEnum.XS }
            onOverlayClick={ closeDialog }
            open={ open }
        >
            <OfferNoteBlock />
        </Modal>
    );
}
